import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/energetemplate',
    name: 'PUT_ENERGETEMPLATE',
    method: 'PUT',
  });

  return [exec, isRequestSuccessed];
});
